module.exports = __webpack_public_path__ + "static/media/view4.424f7c18.jpg";